/* =========================================================
   PokeAlp — Précommandes (JS override v3)
   Maintient l'état "Précommander" sur les formulaires
   produits taggés "preorder", peu importe l'inventaire.
   ========================================================= */

(function () {
  'use strict';

  const PREORDER_FORM_SELECTOR = 'form[data-pokealp-preorder="true"]';
  const PREORDER_BADGE_SELECTOR = 'hdt-badge[data-pokealp-preorder]';
  const FORCE_CLASS = 'pokealp-force-preorder';

  function getPreorderText() {
    try {
      if (window.themeHDN && window.themeHDN.extras && window.themeHDN.extras.preOrder) {
        return window.themeHDN.extras.preOrder;
      }
    } catch (e) {}
    return 'Précommander';
  }

  /**
   * Override le texte d'un bouton submit ATC pour qu'il dise "Précommander".
   * Préserve la casse naturelle (P majuscule, reste en minuscule).
   */
  function forcePreorderButton(form) {
    if (!form) return;
    const btn = form.querySelector('button[type="submit"][name="add"]');
    if (!btn) return;

    const txt = getPreorderText();

    const atcText = btn.querySelector('.hdt-btn-atc_text');
    if (atcText) {
      atcText.textContent = txt;
    } else if (btn.firstElementChild) {
      btn.firstElementChild.textContent = txt;
    } else {
      btn.textContent = txt;
    }

    btn.disabled = false;
    btn.removeAttribute('disabled');
    btn.setAttribute('aria-label', txt);
    btn.classList.add(FORCE_CLASS);
  }

  /**
   * Force l'affichage des badges précommande.
   */
  function forcePreorderBadges(scope) {
    const root = scope || document;
    root.querySelectorAll(PREORDER_BADGE_SELECTOR).forEach(function (badge) {
      badge.hidden = false;
      badge.removeAttribute('hidden');
      const parent = badge.parentElement;
      if (parent && parent.hasAttribute('hidden')) {
        parent.removeAttribute('hidden');
      }
    });
  }

  /**
   * Override du bouton sticky en bas de page (réplique du ATC).
   */
  function forceStickyPreorder() {
    document.querySelectorAll('hdt-sticky-btn-atc').forEach(function (sticky) {
      const formId = sticky.getAttribute('form');
      if (!formId) return;
      const targetForm = document.getElementById(formId);
      if (!targetForm || targetForm.getAttribute('data-pokealp-preorder') !== 'true') return;

      const btn = sticky.querySelector('button[name="add"]');
      if (!btn) return;
      if (btn.firstElementChild) {
        btn.firstElementChild.textContent = getPreorderText();
      } else {
        btn.textContent = getPreorderText();
      }
      btn.disabled = false;
      btn.removeAttribute('disabled');
      // Style cohérent avec le bouton principal
      btn.style.backgroundColor = '#1b2a4a';
      btn.style.borderColor = '#1b2a4a';
      btn.style.color = '#ffffff';
      btn.style.textTransform = 'none';
    });
  }

  function initialOverride() {
    document.querySelectorAll(PREORDER_FORM_SELECTOR).forEach(function (form) {
      forcePreorderButton(form);
    });
    forcePreorderBadges(document);
    forceStickyPreorder();
  }

  function setupVariantChangeListener() {
    document.addEventListener('variant:change', function (e) {
      const targetForm = e.target.closest(PREORDER_FORM_SELECTOR);
      if (!targetForm) return;

      // setTimeout(0) → passe après le BuyButtons natif Kalles
      setTimeout(function () {
        forcePreorderButton(targetForm);
        forcePreorderBadges(targetForm.closest('section, .shopify-section, body'));
        forceStickyPreorder();
      }, 0);
    });

    // Quick view modal qui charge un fragment async
    document.addEventListener('hdt-quick-view-modal:opened', function () {
      setTimeout(initialOverride, 50);
    });
  }

  function setupMutationObserver() {
    if (typeof MutationObserver !== 'function') return;

    const observer = new MutationObserver(function (mutations) {
      let needsReapply = false;
      mutations.forEach(function (m) {
        if (m.type === 'childList' && m.addedNodes.length) {
          for (let i = 0; i < m.addedNodes.length; i++) {
            const node = m.addedNodes[i];
            if (node.nodeType === 1 && (
              node.matches && node.matches(PREORDER_FORM_SELECTOR) ||
              node.querySelector && node.querySelector(PREORDER_FORM_SELECTOR)
            )) {
              needsReapply = true;
              break;
            }
          }
        }
      });
      if (needsReapply) {
        setTimeout(initialOverride, 0);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialOverride();
      setupVariantChangeListener();
      setupMutationObserver();
    });
  } else {
    initialOverride();
    setupVariantChangeListener();
    setupMutationObserver();
  }
})();

/* =========================================================
   PokeAlp — Buy Now button (v1)
   ========================================================= */
(function () {
  'use strict';

  function getQuantity(btn) {
    var form = btn.closest('form') || btn.closest('.hdt-product__buy-button');
    if (!form) return 1;
    var input = form.querySelector('input[name="quantity"], input[type="number"]');
    if (input) {
      var val = parseInt(input.value, 10);
      return val > 0 ? val : 1;
    }
    return 1;
  }

  function handleBuyNow(e) {
    var btn = e.currentTarget;
    if (btn.classList.contains('is-loading')) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    var qty = getQuantity(btn);
    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty }] })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Cart add failed');
      window.location.href = '/checkout';
    })
    .catch(function () {
      btn.classList.remove('is-loading');
      var form = btn.closest('form');
      if (form) form.submit();
    });
  }

  function bindBuyNowButtons(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-pokealp-buynow]').forEach(function (btn) {
      if (btn.hasAttribute('data-pokealp-buynow-bound')) return;
      btn.setAttribute('data-pokealp-buynow-bound', '');
      btn.addEventListener('click', handleBuyNow);
    });
  }

  function setupBuyNowVariantSync() {
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (input.name !== 'id' || input.type !== 'hidden') return;
      var form = input.closest('form');
      if (!form) return;
      var wrapper = form.closest('.hdt-product__buy-button') || form.parentElement;
      if (!wrapper) return;
      wrapper.querySelectorAll('[data-pokealp-buynow]').forEach(function (btn) {
        btn.setAttribute('data-variant-id', input.value);
      });
    });
  }

  function initBuyNow() {
    bindBuyNowButtons();
    setupBuyNowVariantSync();
    if (typeof MutationObserver === 'function') {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes.length) { bindBuyNowButtons(); break; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBuyNow);
  } else {
    initBuyNow();
  }
})();